<div class="db-start-ai-website-building__content">
  <db-create-ai-assistant [websiteId]="0" [isOnboarding]="true" [forRecreateFirstTime]='true' [showThemeNotification]="true" [user]="null" [isFromGenerate]="false" [website]="null" [builderPlugin]="null" [elementorPlugin]="null"></db-create-ai-assistant>
</div>
